import { ApiResult } from "common/models";
import { HttpClient } from "common/services/http-client.service";
import { withApiResponse } from "common/utils/rtk-query.util";
import { configConfig } from "../config/config.config";

export interface ConfigurationItem {
  id: number;
  doc_type_id: number;
  config_name: string;
  extraction_model: string;
  document_context: string;
  is_active: boolean;
  is_deleted: boolean;
  created_by_email: string;
  created_by: string;
  chat_enabled: boolean;
  created_on: string;
  updated_on: string;
  fields: {
    config_id: number;
    field_id: number;
    field_name: string;
    field_key: string;
    field_description: string;
    data_type: string;
    validation_rules: string;
    ui_position_order: number;
    is_active: boolean;
    is_deleted: boolean;
    qc_rule: string | null;
    updated_on: string;
  }[];

  title: string;
  status: string;
  company: string;
  department: string;
  createdBy: string;
  createdOn: string;
  // Additional optional legacy fields
  config_payload?: string;
  document_type?: string;
  documentType?: string | number;
  company_name?: string;
  data_exposer?: string;
  field_context?: string;
  chat_exposure?: boolean;
  clause_extraction?: string;
  summarization_fields?: string;
  group_by_field?: string;
  batch_process_exposure?: boolean;
  sharepoint_url?: string;
  created_time?: string;
  last_updated_by?: string;
  last_updated_on?: string;
}

// export interface CreateConfigurationRequest {
//   config_name: string;
//   config_payload: string;
//   document_type: string;
//   created_by: string;
//   company_name: string;
//   data_exposer: string;
//   department: string;
//   document_context: string;
//   field_context: string;
//   extraction_model: string;
//   chat_exposure: string;
//   clause_extraction: string;
//   summarization_fields: string;
//   group_by_field: string;
//   batch_process_exposure: boolean;
//   sharepoint_url: string;
//   created_time: string;
//   document_type_id: number
// }

export interface CreateConfigurationRequest {
  doc_type_id: number;
  config_name: string;
  extraction_model: string;
  document_context: string;
  is_active: boolean;
  is_deleted: boolean;
  created_by_email: string;
  created_by: string;
  chat_enabled: boolean;
  fields: {
    config_id: number;
    field_name: string;
    field_key: string;
    field_description: string;
    data_type: string;
    validation_rules: string;
    ui_position_order: number;
    is_active: boolean;
    is_deleted: boolean;
  }[];
}

export interface UpdateConfigurationRequest {
  config_id: number;
  config_name: string;
  config_payload: string;
  document_type: string;
  created_by: string;
  company_name: string;
  data_exposer: string;
  department: string;
  document_context: string;
  field_context: string;
  extraction_model: string;
  chat_exposure: string;
  clause_extraction: string;
  summarization_fields: string;
  group_by_field: string;
  batch_process_exposure: boolean;
  sharepoint_url: string;
  created_time: string;
  // Additional required fields for update
  files_name: string;
  config_file_department: string;
  field_names: string;
  validation_rules: string;
  uploaded_by: string;
  data_extracted: string;
  data_edited: string;
  status: string;
  updated_fields: string;
  extracted_by: string;
  approved_by: string;
  extracted_date: string;
  approved_date: string;
  visiable_filename: string;
  submitted_by: string;
  submitted_on: string;
  last_updated_by: string;
  last_updated_on: string;
  page_number: number;
  document_size: number;
}

export class ConfigService extends HttpClient {
  public static getAllConfigurations() {
    const config = configConfig.getAllConfigurations();
    return withApiResponse<ConfigurationItem[]>(async () => {
      const response = await this.invokeApi<ConfigurationItem[]>(config);
      return new ApiResult<ConfigurationItem[]>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static createConfiguration(
    configData: CreateConfigurationRequest,
    userEmail: string
    // headers: Record<string, string> = {}
  ) {
    const config = configConfig.createConfiguration(configData);
    // X-User-Email header: Backend uses this to populate created_by_email field
    const headers = { "X-User-Email": userEmail };

    return withApiResponse<ConfigurationItem>(async () => {
      const response = await this.invokeApi<ConfigurationItem>(config, headers);
      return new ApiResult<ConfigurationItem>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static updateConfiguration(configData: any) {
    const config = configConfig.updateConfiguration(configData);
    return withApiResponse<ConfigurationItem>(async () => {
      const response = await this.invokeApi<ConfigurationItem>(config);
      return new ApiResult<ConfigurationItem>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static deleteConfiguration(configId: number) {
    const config = configConfig.deleteConfiguration(configId);
    return withApiResponse<void>(async () => {
      const response = await this.invokeApi<void>(config);
      return new ApiResult<void>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }
}
